import React, { Component } from 'react';
import {withRouter} from 'react-router-dom'
import { Grid, Row, Col, PageHeader } from 'react-bootstrap';
import {auth, isAnonymous} from "../App";
import Crummy from "../Components/Crummy";

class Home extends Component {


  breadcumb() {
    return (
      <Crummy paths={[{'name': 'Home', 'path': '/'},]}/>
    );
  }

  render() {
    var user = auth.currentUser;
    var userName = null;
    if (user) {
      userName =  user.uid;
    } else {
      userName =  "not logged in";
    }

    return (
      <Grid>
        {this.breadcumb()}
        <Row>
            <PageHeader>Zoetrove</PageHeader>
          </Row>
            <Row>
                Hello {userName} { isAnonymous() ? "Anonymous" : "not anonymous"}
            </Row>
            <Row>
                <Col xs={6} md={4}><code>&lt;{'Col xs={6} md={4}'} /&gt;</code></Col>
            </Row>
        </Grid>
    );
  }
}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/pages/Home.jsx